// начать повторы с интервалом 2 сек
var timerIdTel = setInterval(function() {
  //в переменную content попало содержимое элемента, имеющего id="...
  var q800=document.getElementById("q800").innerHTML;
  q800=q800.replace("<div>","");
  q800=q800.replace("</div>","");
  if(document.getElementById("q800Print"))document.getElementById("q800Print").innerHTML = q800;
  if(document.getElementById("q800Print2"))document.getElementById("q800Print2").innerHTML = q800;
  link_q800=q800.replace("(","");
  link_q800=link_q800.replace(")","");
  link_q800=link_q800.replace(/-/g,"");
  link_q800=link_q800.replace(/ /g,"");
  if(document.getElementById('q800Print'))document.getElementById('q800Print').href = 'tel:'+link_q800;
  if(document.getElementById("q800Print2"))document.getElementById('q800Print2').href = 'tel:'+link_q800;
  if(document.getElementById("link_q800Print"))document.getElementById('link_q800Print').href = 'tel:'+link_q800;
  if(document.getElementById("link_q800Print2"))document.getElementById('link_q800Print2').href = 'tel:'+link_q800;

  let numb = $('#sev').html().replace(/\D+/g,"");
  if(numb === '74994954273'){
    console.log('job');
    if(document.getElementById("q800Print"))document.getElementById("q800Print").innerHTML = '8 (800) 444-03-36';
    if(document.getElementById("q800Print2"))document.getElementById("q800Print2").innerHTML = '8 (800) 444-03-36';
    if(document.getElementById("q800Print2"))document.getElementById('q800Print2').href = 'tel:88004440336';
    if(document.getElementById("link_q800Print"))document.getElementById('link_q800Print').href = 'tel:88004440336';
    if(document.getElementById("link_q800Print2"))document.getElementById('link_q800Print2').href = 'tel:88004440336';
  }


  //Севастопольский детелингов
  var sevastopolDet=document.getElementById("sevastopolDet").innerHTML;
  sevastopolDet=sevastopolDet.replace("<div>","");
  sevastopolDet=sevastopolDet.replace("</div>","");
  if(document.getElementById("sevastopolDetPrint"))document.getElementById("sevastopolDetPrint").innerHTML = sevastopolDet;
  if(document.getElementById("sevastopolDetPrint2"))document.getElementById("sevastopolDetPrint2").innerHTML = sevastopolDet;
  link_sevastopolDet=sevastopolDet.replace("(","");
  link_sevastopolDet=link_sevastopolDet.replace(")","");
  link_sevastopolDet=link_sevastopolDet.replace(/-/g,"");
  link_sevastopolDet=link_sevastopolDet.replace(/ /g,"");
  if(document.getElementById("sevastopolDetPrint"))document.getElementById('sevastopolDetPrint').href = 'tel:'+link_sevastopolDet;
  if(document.getElementById("sevastopolDetPrint2"))document.getElementById('sevastopolDetPrint2').href = 'tel:'+link_sevastopolDet;

  //Удальцова
  var ydal=document.getElementById("ydal").innerHTML;
  ydal=ydal.replace("<div>","");
  ydal=ydal.replace("</div>","");
  if(document.getElementById("ydalPrint"))document.getElementById("ydalPrint").innerHTML = ydal;//
  if(document.getElementById("ydalPrint2"))document.getElementById("ydalPrint2").innerHTML = ydal;
  if(document.getElementById("ydalPrint3"))document.getElementById("ydalPrint3").innerHTML = ydal;
  if(document.getElementById("ydalPrint4"))document.getElementById("ydalPrint4").innerHTML = ydal;
  if(document.getElementById("ydalPrint5"))document.getElementById("ydalPrint5").innerHTML = ydal;
  link_ydal=ydal.replace("(","");
  link_ydal=link_ydal.replace(")","");
  link_ydal=link_ydal.replace(/-/g,"");
  link_ydal=link_ydal.replace(/ /g,"");
  if(document.getElementById("ydalPrint"))document.getElementById('ydalPrint').href = 'tel:'+link_ydal;
  if(document.getElementById("ydalPrint2"))document.getElementById('ydalPrint2').href = 'tel:'+link_ydal;
  if(document.getElementById("ydalPrint3"))document.getElementById('ydalPrint3').href = 'tel:'+link_ydal;
  if(document.getElementById("ydalPrint4"))document.getElementById('ydalPrint4').href = 'tel:'+link_ydal;
  if(document.getElementById("ydalPrint5"))document.getElementById('ydalPrint5').href = 'tel:'+link_ydal;
  //Лобненская
  var lbn=document.getElementById("lbn").innerHTML;
  lbn=lbn.replace("<div>","");
  lbn=lbn.replace("</div>","");
  if(document.getElementById("lbnPrint"))document.getElementById("lbnPrint").innerHTML = lbn;
  if(document.getElementById("lbnPrint2"))document.getElementById("lbnPrint2").innerHTML = lbn;
  if(document.getElementById("lbnPrint3"))document.getElementById("lbnPrint3").innerHTML = lbn;
  if(document.getElementById("lbnPrint4"))document.getElementById("lbnPrint4").innerHTML = lbn;
  if(document.getElementById("lbnPrint5"))document.getElementById("lbnPrint5").innerHTML = lbn;
  setTimeout(()=>{
    console.log('set '+lbn);
    if(lbn === '8 (499) 495-43-27'){
      if(document.getElementById("link_com_trans_text"))document.getElementById("link_com_trans_text").innerHTML = lbn;
      if(document.getElementById("link_com_trans2_text"))document.getElementById("link_com_trans2_text").innerHTML = lbn;
    } else {
      if(document.getElementById("link_com_trans_text"))document.getElementById("link_com_trans_text").innerHTML = '8 (499) 495-44-38';
      if(document.getElementById("link_com_trans2_text"))document.getElementById("link_com_trans2_text").innerHTML = '8 (499) 495-44-38';
    }
  },1);
  link_lbn=lbn.replace("(","");
  link_lbn=link_lbn.replace(")","");
  link_lbn=link_lbn.replace(/-/g,"");
  link_lbn=link_lbn.replace(/ /g,"");
  if(document.getElementById("lbnPrint"))document.getElementById('lbnPrint').href = 'tel:'+link_lbn;
  if(document.getElementById("lbnPrint2"))document.getElementById('lbnPrint2').href = 'tel:'+link_lbn;
  if(document.getElementById("lbnPrint3"))document.getElementById('lbnPrint3').href = 'tel:'+link_lbn;
  if(document.getElementById("lbnPrint4"))document.getElementById('lbnPrint4').href = 'tel:'+link_lbn;
  if(document.getElementById("lbnPrint5"))document.getElementById('lbnPrint5').href = 'tel:'+link_lbn;
  setTimeout(()=>{
    console.log('set '+link_lbn);
    if(lbn === '8 (499) 495-43-27'){
      if(document.getElementById("link_com_trans"))document.getElementById('link_com_trans').href = 'tel:'+link_lbn;
      if(document.getElementById("link_com_trans2"))document.getElementById('link_com_trans2').href = 'tel:'+link_lbn;
    } else {
      if(document.getElementById("link_com_trans"))document.getElementById('link_com_trans').href = 'tel:74994954438';
      if(document.getElementById("link_com_trans2"))document.getElementById('link_com_trans2').href = 'tel:74994954438';
    }
  },1);

  //Севастопольский
  var sev=document.getElementById("sev").innerHTML;
  sev=sev.replace("<div>","");
  sev=sev.replace("</div>","");
  if(document.getElementById("sevPrint"))document.getElementById("sevPrint").innerHTML = sev;
  if(document.getElementById("sevPrint2"))document.getElementById("sevPrint2").innerHTML = sev;//
  if(document.getElementById("sevPrint3"))document.getElementById("sevPrint3").innerHTML = sev;//
  if(document.getElementById("sevPrint4"))document.getElementById("sevPrint4").innerHTML = sev;//
  if(document.getElementById("sevPrint5"))document.getElementById("sevPrint5").innerHTML = sev;//
  link_sev=sev.replace("(","");
  link_sev=link_sev.replace(")","");
  link_sev=link_sev.replace(/-/g,"");
  link_sev=link_sev.replace(/ /g,"");
  if(document.getElementById("sevPrint"))document.getElementById('sevPrint').href = 'tel:'+link_sev;
  if(document.getElementById("sevPrint2"))document.getElementById('sevPrint2').href = 'tel:'+link_sev;
  if(document.getElementById("sevPrint3"))document.getElementById('sevPrint3').href = 'tel:'+link_sev;
  if(document.getElementById("sevPrint4"))document.getElementById('sevPrint4').href = 'tel:'+link_sev;
  if(document.getElementById("sevPrint5"))document.getElementById('sevPrint5').href = 'tel:'+link_sev;

  //Калужская
  var klg=document.getElementById("klg").innerHTML;
  klg=klg.replace("<div>","");
  klg=klg.replace("</div>","");
  if(document.getElementById("klgPrint"))document.getElementById("klgPrint").innerHTML = klg;
  if(document.getElementById("klgPrint2"))document.getElementById("klgPrint2").innerHTML = klg;//
  if(document.getElementById("klgPrint3"))document.getElementById("klgPrint3").innerHTML = klg;//
  if(document.getElementById("klgPrint4"))document.getElementById("klgPrint4").innerHTML = klg;//
  if(document.getElementById("klgPrint5"))document.getElementById("klgPrint5").innerHTML = klg;//
  link_klg=klg.replace("(","");
  link_klg=link_klg.replace(")","");
  link_klg=link_klg.replace(/-/g,"");
  link_klg=link_klg.replace(/ /g,"");
  if(document.getElementById("klgPrint"))document.getElementById('klgPrint').href = 'tel:'+link_klg;
  if(document.getElementById("klgPrint2"))document.getElementById('klgPrint2').href = 'tel:'+link_klg;
  if(document.getElementById("klgPrint3"))document.getElementById('klgPrint3').href = 'tel:'+link_klg;
  if(document.getElementById("klgPrint4"))document.getElementById('klgPrint4').href = 'tel:'+link_klg;
  if(document.getElementById("klgPrint5"))document.getElementById('klgPrint5').href = 'tel:'+link_klg;

  //Нижегородская
  /*var njg=document.getElementById("njg").innerHTML;
  njg=njg.replace("<div>","");
  njg=njg.replace("</div>","");
  document.getElementById("njgPrint").innerHTML = njg;
  document.getElementById("njgPrint2").innerHTML = njg;
  document.getElementById("njgPrint3").innerHTML = njg;
  link_njg=njg.replace("(","");
  link_njg=link_njg.replace(")","");
  link_njg=link_njg.replace(/-/g,"");
  link_njg=link_njg.replace(/ /g,"");
  document.getElementById('link_njgPrint').href = 'tel:'+link_njg;
  document.getElementById('link_njgPrint2').href = 'tel:'+link_njg;//
  document.getElementById('link_njgPrint3').href = 'tel:'+link_njg;//
  */
}, 2000);

// через 5 сек остановить повторы
setTimeout(function() {
  clearInterval(timerIdTel);
  //alert( 'стоп' );
}, 5000);